module.exports = __webpack_public_path__ + "static/media/CAM-03.fb22d78e.webp";